import { render, staticRenderFns } from "./HeaderIndex.vue?vue&type=template&id=1b0a412c"
import script from "./HeaderIndex.vue?vue&type=script&lang=js"
export * from "./HeaderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports